import React,{ useRef } from 'react';
import { 
    Show,
    SimpleShowLayout,
    ListButton,
    CardActions
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import RecertificatePrint from './RecertificatePrint'
import { Redirect } from 'react-router-dom';

let uid = null;

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px 30px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '700px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },

    body :{
        display: 'inline-block', 
        margin: '5px 20px 5px 35px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '700px',
        alignItems: 'middle',
        border: '0',
        fontSize: '12px',
        textAlign: 'left'
    },
    p: {
        fontSize: '12px',
    },
    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
        marginTop: '1em',
        marginLeft: '30px',
        marginBottom: '1em',
       
    }
})


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const SampleActions = ({basePath}) => (
    <CardActions style={cardActionStyle}>
        <ListButton  
        label='List' 
        basePath={'/recertificate?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
        />
    </CardActions>
);


const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <RecertificatePrint record={record} classes={classes} ref={componentRef} />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };
const GetKey=({ record }) => (
    console.log(record),
    uid = (record.uid)? record.uid:uid,
    (uid)? '': <Redirect to="/userslist" />
);


const RecertificateView= ({ classes, ...props }) => (
    <Show
    {...props}
    /* disable the app title change when shown */
    title="Recertificate View "
    actions={<SampleActions />} 
    >
    <SimpleShowLayout>
    <GetKey props={props} />
    <Print />
    </SimpleShowLayout>
</Show>
)

export default RecertificateView
